import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, TextField, Typography } from '@mui/material';
import { useFormikContext } from 'formik';

import type { SurveyDetailUpdate } from 'src/types/survey';

import { SettingsGroup } from '../SettingsGroup';

const GeneralSettings: FC = () => {
  const { t } = useTranslation('survey');
  const { values, handleChange, errors } =
    useFormikContext<SurveyDetailUpdate>();

  return (
    <SettingsGroup headline={t('settings.general.headline')}>
      <Box
        sx={(theme) => ({
          display: 'flex',
          flexDirection: 'column',
          gap: 1,
          padding: theme.spacing(1),
        })}
      >
        <Typography variant="body3" component="label" htmlFor="name">
          {t('settings.general.surveyName')}
        </Typography>
        <TextField
          sx={{ maxWidth: '400px' }}
          value={values.name}
          onChange={handleChange}
          name="name"
          id="name"
        />
        {errors && (
          <Typography variant="body4" color="error">
            {errors.name}
          </Typography>
        )}
      </Box>
    </SettingsGroup>
  );
};
export default GeneralSettings;
